import { Store } from 'vuex';
import { RootState } from '../types';
import { hasFeature, setFeaturesFromAccessToken } from '../../lib/feature';
import { AuthGetterKeys, SET_ACCESS_TOKEN } from '../modules/auth';
import router, {
	getCaslDataFromRoutes,
	PERMISSION_DENIED_PATH,
} from '../../router';

export const featurePlugin = (store: Store<RootState>) => {
	// const accessToken = store.getters[`auth/${AuthGetterKeys.accessToken}`];

	return store.subscribe(mutation => {
		switch (mutation.type) {
			case `auth/${SET_ACCESS_TOKEN}`:
				{
					const accessToken = mutation.payload;

					setFeaturesFromAccessToken(accessToken);
					if (!accessToken) {
						// not logged in. Page access will be handled by route guard
						// We should not do any extra rerouting here, otherwise might cause errors like:
						// Navigation cancelled from "/some/path" to "/permission-denied" with a new navigation.
						return;
					}

					if (router.currentRoute.matched.length) {
						// check permission to route
						const { feature } = getCaslDataFromRoutes(
							router.currentRoute.matched,
						);
						const hasAccess = hasFeature(feature);
						if (
							hasAccess &&
							router.currentRoute.path === PERMISSION_DENIED_PATH
						) {
							router.back();
						} else if (
							!hasAccess &&
							router.currentRoute.path !== PERMISSION_DENIED_PATH
						) {
							router.push({ path: PERMISSION_DENIED_PATH });
						}
					} else {
						// seems router not fully initialized. No need to do anything
						// TODO: confirm the above statement
					}
				}
				break;
		}
	});
};
